import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import UsersDataGrid from '../../components/Users/DataGrid';
import InviteUser from '../../components/Users/InviteUser';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import InvitationsDataGrid from '../../components/Users/Invitations';
import ImportData from '../../components/Users/ImportData';

const UsersTab = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    document.title = "Admin Page - iLead CRM";
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%', // Ensure it takes the full available height
      }}
    >
      {/* Header Section */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexShrink: 0, // Prevent shrinking
          mb: 1, // Margin below the header
        }}
      >
        <h3>Users</h3>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" onClick={() => setModalOpen(true)}>
            Invite User
          </Button>
          <InviteUser open={isModalOpen} onClose={() => setModalOpen(false)} />
        </Box>
      </Box>
      {/* Content Section */}
      <Box
        sx={{
          flexGrow: 1, // Fills the remaining space
          overflow: 'auto', // Enables scrolling if content overflows
        }}
      >
        <UsersDataGrid />
      </Box>
    </Box>
  );
};

const InvitationsTab = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%', // Ensures it takes full height of the parent
      }}
    >
      <Box
        sx={{
          flexGrow: 1, // Allows the box to grow and take remaining space
          overflow: 'auto', // Ensures content scrolls if necessary
        }}
      >
        <InvitationsDataGrid
          sx={{
            height: '100%', // Ensures the DataGrid fills the available space
          }}
        />
      </Box>
    </Box>
  );
};

const ImportDataTab = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%', // Ensures it takes full height of the parent
      }}
    >
      <Box
        sx={{
          flexGrow: 1, // Allows the box to grow and take remaining space
          overflow: 'auto', // Ensures content scrolls if necessary
        }}
      >
        <ImportData />
      </Box>
    </Box>
  );
};

const AdminPage = () => {
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 70px)', // Full height of the viewport
        p: 2,
      }}
    >
      <Paper
        elevation={1}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%', // Paper takes full available height
        }}
      >
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              flexShrink: 0, // Prevents the tab section from shrinking
            }}
          >
            <TabList onChange={handleChange}>
              <Tab label="Users" value="1" />
              <Tab label="Invitations" value="2" />
              <Tab label="Import Data" value="3" />
            </TabList>
          </Box>

          {/* Tab Panels */}
          <Box
            sx={{
              flexGrow: 1, // Makes the TabPanel take the remaining height
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden', // Prevents unnecessary scrolling on the entire panel
            }}
          >
            <TabPanel
              value="1"
              sx={{
                display: value === "1" ? 'flex' : 'none', // Only show when active
                flexDirection: 'column',
                height: '100%', // Ensure TabPanel takes full height
              }}
            >
              <UsersTab />
            </TabPanel>
            <TabPanel
              value="2"
              sx={{
                display: value === "2" ? 'flex' : 'none', // Only show when active
                flexDirection: 'column',
                height: '100%', // Ensures TabPanel takes full height
              }}
            >
              <InvitationsTab />
            </TabPanel>
            <TabPanel
              value="3"
              sx={{
                display: value === "3" ? 'flex' : 'none', // Only show when active
                flexDirection: 'column',
                height: '100%', // Ensures TabPanel takes full height
              }}
            >
              <ImportDataTab />
            </TabPanel>
          </Box>
        </TabContext>
      </Paper>
    </Box>
  );
};

export default AdminPage;

